










































































































































































































import Vue from 'vue'
import { debounce } from 'lodash'
import { productIcon, folderIcon, fileIcon } from '../../helper/constants'
import { UniversalSearchService } from '../../services'
import { getHighlightedDescription } from '@/helper'

export default Vue.extend({
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchText: '',
      open: true,
      limit: 10,
      page: 1,
      totalSearchCount: 0,
      searchData: [],
      loading: false,
      openModal: false,
      isSearchDataAvailable: true,
      recentSearches: [],
      searchIds: [],
      productTitleMapping: {},
      uniqueProductIds: [],
      searchIcons: {
        product: productIcon,
        category: folderIcon,
        post: fileIcon
      }
    }
  },
  mounted() {
    this.recentSearches =
      JSON.parse(window.localStorage.getItem('searchItems')) || []
  },
  watch: {
    showModal(val: boolean) {
      this.openModal = val
    }
  },
  methods: {
    closeModal() {
      this.searchText = ''
      this.resetData()
      this.$emit('close')
    },
    createDebounce: debounce(function() {
      this.searchContent()
    }, 500),
    async searchFullText() {
      this.loading = true
      const payload = {
        searchKey: this.searchText,
        pageLimit: this.limit,
        pageNumber: this.page
      }
      const newData = await UniversalSearchService.searchItems(payload)
      const productIds = []
      if (newData.length) {
        for (const data of newData) {
          if (!this.searchIds.includes(data.typeId)) {
            if (!this.uniqueProductIds.includes(data.productId)) {
              this.uniqueProductIds.push(data.productId)
              productIds.push(data.productId)
            }
            if (data.description) {
              data.description = getHighlightedDescription(
                data.description,
                this.searchText.split(' '),
                0
              )
            }
            this.searchData.push(data)
            this.searchIds.push(data.typeId)
          }
        }
        if (productIds.length) {
          this.fetchProductTitle(productIds)
        }
        this.isSearchDataAvailable = true
        this.nextSearchData()
      } else {
        this.isSearchDataAvailable = false
      }
      this.loading = false
    },
    searchContent() {
      this.resetData()
      if (!this.searchText) {
        this.isSearchDataAvailable = true
        return
      }
      this.searchCount()
      this.searchFullText()
    },
    resetData() {
      this.page = 1
      this.searchData = []
      this.searchIds = []
      this.productTitleMapping = {}
      this.uniqueProductIds = []
    },
    async fetchProductTitle(productIds) {
      const products = await UniversalSearchService.getProductTitles({
        productIds: productIds
      })
      this.productTitleMapping = { ...this.productTitleMapping, ...products }
    },
    changeRoute(option) {
      this.recentSearches =
        JSON.parse(window.localStorage.getItem('searchItems')) || []
      if (!this.recentSearches.includes(this.searchText.toLocaleLowerCase())) {
        if (this.recentSearches.length === 3) this.recentSearches.pop()
        this.recentSearches.splice(0, 0, this.searchText.toLocaleLowerCase())
      }
      window.localStorage.setItem(
        'searchItems',
        JSON.stringify(this.recentSearches)
      )
      this.searchText = ''
      this.searchData = []
      this.$router.push({
        name:
          option.type === 'product'
            ? 'product-overview'
            : option.type === 'category'
            ? 'category-overview'
            : 'post-overview',
        params: {
          id: option.productId,
          category_id: option.categoryId,
          post_id: option.typeId
        }
      })
      this.closeModal()
    },
    async searchCount() {
      const payload = {
        searchKey: this.searchText
      }
      const { totalCount } = await UniversalSearchService.searchCount(payload)
      this.totalSearchCount = totalCount
    },
    nextSearchData() {
      const optionList = document.getElementById('optionList')
      if (optionList) {
        optionList.onscroll = () => {
          const offset = (this.page + 1) * this.limit - this.limit
          if (this.totalSearchCount - offset < 0) {
            return
          }
          const lastDiv = document.querySelector('#optionList > div:last-child')
          const optionListOffset =
            optionList.scrollTop + optionList.clientHeight
          const lastDivOffset = lastDiv.scrollTop + lastDiv.clientHeight
          if (optionListOffset > lastDivOffset - 10) {
            this.page++
            this.searchFullText()
          }
        }
      }
    }
  }
})
